// src/components/pages/Homologation/tabs/HomologationItemDialog.jsx
import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Autocomplete } from '@mui/material';

import Input from '../../../form/Input';
import TextArea from '../../../form/TextArea';
import Checkbox from '../../../form/Checkbox';
import Select from '../../../form/Select';

import * as UsuarioAPI from '../../../../api/usuario';

function HomologationItemDialog({ open, draft, options, onChange, onSalvar, onCancelar, context }) {
    const [usuarios, setUsuarios] = useState([]);
    const [inputUsuario, setInputUsuario] = useState('');
    const [usuariosSelecionados, setUsuariosSelecionados] = useState([]);

    const isDisabled = !context?.isResponsavelHomologacao;

    useEffect(() => {
        if (!open) return;

        setUsuariosSelecionados(Array.isArray(draft?.pessoasSelecionadas) ? draft.pessoasSelecionadas : []);
    }, [open, draft]);

    useEffect(() => {
        const carregarUsuarios = async () => {
            try {
                if (!open) return;

                const result = await UsuarioAPI.datalist?.({
                    globalFilter: inputUsuario,
                });

                setUsuarios(Array.isArray(result) ? result : []);
            } catch (error) {
                console.error(error);
                setUsuarios([]);
            }
        };

        carregarUsuarios();
    }, [open, inputUsuario]);

    const handleSalvar = () => {
        const payload = {
            ...draft,
            usarPermissoes: !!draft?.usarPermissoes,
            pessoasSelecionadas: usuariosSelecionados.map((u) => ({
                id: u.id,
                descricao: u.descricao,
            })),
        };

        onSalvar(payload);
    };

    const usarPermissoes = !!draft?.usarPermissoes;

    return (
        <Dialog open={open} onClose={onCancelar} maxWidth="lg" fullWidth>
            <>
                <DialogTitle>{draft?.uuid ? 'Editar Item da Homologação' : 'Adicionar Item da Homologação'}</DialogTitle>

                <DialogContent>
                    <div>
                        <Input
                            text="Descrição"
                            name="descricao"
                            inputWidth="300px"
                            value={draft.descricao || ''}
                            handleOnChange={onChange}
                        />

                        <Select
                            text="Menu"
                            name="menuId"
                            options={options.optionsMenu || []}
                            value={draft.menuId || ''}
                            handleOnChange={onChange}
                            isEnum={false}
                            notOptNull={false}
                        />

                        <Select
                            text="SubMenu"
                            name="menuSubId"
                            options={options.optionsMenuSub || []}
                            value={draft.menuSubId || ''}
                            handleOnChange={onChange}
                            isEnum={false}
                            notOptNull={false}
                        />

                        <Select
                            text="Situação"
                            name="situacaoId"
                            options={options.optionsSituacao || []}
                            value={draft.situacaoId || ''}
                            handleOnChange={onChange}
                            isEnum={false}
                            notOptNull={false}
                        />

                        <Select
                            text="Operação Selecionada"
                            name="operacaoId"
                            options={options.optionsOperacao || []}
                            value={draft.operacaoId || ''}
                            handleOnChange={onChange}
                            isEnum={false}
                            notOptNull={false}
                        />

                        <Checkbox
                            text="Gerar"
                            title="Gerar automaticamente todos os usuários que possuem permissão para a rotina, ao marcar essa opção não precisa selecionar usuários no select abaixo"
                            name="usarPermissoes"
                            value={draft.usarPermissoes}
                            checked={!!draft.usarPermissoes}
                            handleOnChange={onChange}
                        />

                        <Checkbox
                            text="Ativo"
                            name="ativo"
                            value={draft.ativo}
                            checked={!!draft.ativo}
                            handleOnChange={onChange}
                        />
                    </div>

                    <div
                        style={{
                            marginTop: 16,
                            marginBottom: 16,
                            display: 'flex',
                            gap: 16,
                            alignItems: 'flex-start',
                        }}
                    >
                        <div style={{ minWidth: 220 }}>
                            <Select
                                text="Papel"
                                name="situacaoPessoaId"
                                options={options.optionsPapel || []}
                                value={draft.situacaoPessoaId || ''}
                                handleOnChange={onChange}
                                isEnum={false}
                                notOptNull={false}
                            />
                        </div>

                        <div style={{ flex: 1 }}>
                            <Autocomplete
                                multiple
                                options={Array.isArray(usuarios) ? usuarios : []}
                                value={usuariosSelecionados}
                                disabled={usarPermissoes}
                                getOptionLabel={(option) => option?.descricao || ''}
                                isOptionEqualToValue={(option, value) => String(option?.id) === String(value?.id)}
                                onInputChange={(event, newInputValue) => {
                                    setInputUsuario(newInputValue);
                                }}
                                onChange={(event, newValue) => {
                                    setUsuariosSelecionados(newValue || []);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Pessoas do Item"
                                        placeholder={
                                            usarPermissoes
                                                ? 'Desabilitado porque o item usará permissões automáticas'
                                                : 'Digite para buscar e selecionar uma ou mais pessoas'
                                        }
                                    />
                                )}
                            />
                        </div>
                    </div>

                    <div>
                        <TextArea
                            text="Objetivo Base Snapshot"
                            name="objetivoBaseSnapshot"
                            value={draft.objetivoBaseSnapshot || ''}
                            handleOnChange={onChange}
                            textAlign="left"
                            linhas="4"
                            colunas="120"
                        />
                    </div>

                    <div>
                        <TextArea
                            text="Objetivo Complemento"
                            name="objetivoComplemento"
                            value={draft.objetivoComplemento || ''}
                            handleOnChange={onChange}
                            textAlign="left"
                            linhas="4"
                            colunas="120"
                        />
                    </div>

                    <div>
                        <TextArea
                            text="Parametrização"
                            name="parametrizacaoTexto"
                            value={draft.parametrizacaoTexto || ''}
                            handleOnChange={onChange}
                            textAlign="left"
                            linhas="4"
                            colunas="120"
                        />
                    </div>

                    <div>
                        <TextArea
                            text="Critérios de Aceite"
                            name="criteriosAceiteTexto"
                            value={draft.criteriosAceiteTexto || ''}
                            handleOnChange={onChange}
                            textAlign="left"
                            linhas="4"
                            colunas="120"
                        />
                    </div>

                    <div>
                        <Input
                            text="Data Início"
                            name="dataInicio"
                            type="date"
                            inputWidth="180px"
                            value={draft.dataInicio || ''}
                            handleOnChange={onChange}
                        />

                        <Input
                            text="Data Fim"
                            name="dataFim"
                            type="date"
                            inputWidth="180px"
                            value={draft.dataFim || ''}
                            handleOnChange={onChange}
                        />

                        <Input
                            text="Data Homologado"
                            name="dataHomologado"
                            type="date"
                            inputWidth="180px"
                            value={draft.dataHomologado || ''}
                            handleOnChange={onChange}
                        />
                    </div>

                    <div>
                        <Input
                            text="Versão Front"
                            title="Versão homologada do frontEnd"
                            name="versaoFrontHomologada"
                            inputWidth="200px"
                            value={draft.versaoFrontHomologada || ''}
                            handleOnChange={onChange}
                        />

                        <Input
                            text="Versão Back"
                            title="Versão homologada do backEnd"
                            name="versaoBackHomologada"
                            inputWidth="200px"
                            value={draft.versaoBackHomologada || ''}
                            handleOnChange={onChange}
                        />
                    </div>

                    <div>
                        <TextArea
                            text="Observação"
                            name="observacao"
                            value={draft.observacao || ''}
                            handleOnChange={onChange}
                            textAlign="left"
                            linhas="4"
                            colunas="120"
                        />
                    </div>
                </DialogContent>

                <DialogActions>
                    <Button onClick={onCancelar} color="secondary" variant="contained">
                        Cancelar
                    </Button>
                    <Button onClick={handleSalvar} color="success" variant="contained" disabled={isDisabled}>
                        {draft?.uuid ? `${isDisabled ? 'Visualizar' : 'Editar'}` : 'Adicionar'}
                    </Button>
                </DialogActions>
            </>
        </Dialog>
    );
}

export default HomologationItemDialog;
